const state = {
  sidebar: {
    opened: false,
    withoutAnimation: false,
  },
  config: {
    googleMaps: {
      apiKey: 'AIzaSyBNAqPrTQoz9P4NBlDDyfxrnKiafkaL8iQ',
    },
    windowMatchSizeLg: '(min-width: 992px)',
    palette: {
      primary: '#4ae387',
      danger: '#e34a4a',
      info: '#4ab2e3',
      success: '#db76df',
      warning: '#f7cc36',
      white: '#fff',
      black: '#000',
      fontColor: '#34495e',
      transparent: 'transparent',
      lighterGray: '#ddd',
    },
  },
  isLoading: true,
  login: false,
  notificacoesTodas: [],
  notificacoes: [],
  changelogs: [],
  notificacoesNaoLidas: [],
  notificacoesLidas: [],
  notificacoesArquivadas: [],
}

const mutations = {
  setLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  TOGGLE_WITHOUT_ANIMATION(state, value) {
    state.sidebar.withoutAnimation = value
  },
  authenticated: state => (state.login = true),
  unauthenticated: state => (state.login = false),
  SET_NOTIFICACOES_TODAS(state, notificacoes) {
    state.notificacoesTodas = notificacoes
  },
  SET_NOTIFICACOES(state, notificacoes) {
    state.notificacoes = notificacoes
  },
  SET_CHANGELOGS(state, notificacoes) {
    state.changelogs = notificacoes
  },
  SET_NOTIFICACOES_NAO_LIDAS(state, notificacoes) {
    state.notificacoesNaoLidas = notificacoes
  },
  SET_NOTIFICACOES_LIDAS(state, notificacoes) {
    state.notificacoesLidas = notificacoes
  },
  SET_NOTIFICACOES_ARQUIVADAS(state, notificacoes) {
    state.notificacoesArquivadas = notificacoes
  },
  ADD_NOTIFICACAO(state, notificacao) {
    state.notificacoesTodas.unshift(notificacao)

    if (notificacao.is_archived) {
      state.notificacoesArquivadas.unshift(notificacao)
    } else if (notificacao.is_read) {
      state.notificacoesLidas.unshift(notificacao)
    } else {
      state.notificacoesNaoLidas.unshift(notificacao)
    }

    if (notificacao.type === 'version_control') {
      state.changelogs.unshift(notificacao)
    } else {
      state.notificacoes.unshift(notificacao)
    }
  },
}

const actions = {
  isToggleWithoutAnimation({ commit }, value) {
    commit('TOGGLE_WITHOUT_ANIMATION', value)
  },
  async fetchFilteredNotificacoes({ commit }, { http, page, status, type, search, limit = 15 }) {
    let url = `${process.env.VUE_APP_URL_API_V2}/notificacoes?page=${page}`
    if (status) url += `&status=${status}`
    if (type) url += `&type=${type}`
    if (search) url += `&filter=${search}`
    if (limit) url += `&limit=${limit}`

    const response = await http
      .get(url)
      .then(res => res.body.dados)
      .catch(err => {
        console.error('Erro ao carregar notificações:', err)
        throw err
      })

    if (!status && !type) {
      commit('SET_NOTIFICACOES_TODAS', response.data)
    } else if (status === 'unread') {
      commit('SET_NOTIFICACOES_NAO_LIDAS', response.data)
    } else if (status === 'read') {
      commit('SET_NOTIFICACOES_LIDAS', response.data)
    } else if (status === 'archived') {
      commit('SET_NOTIFICACOES_ARQUIVADAS', response.data)
    } else if (type === 'version_control') {
      commit('SET_CHANGELOGS', response.data)
    } else {
      commit('SET_NOTIFICACOES', response.data)
    }

    return {
      currentPage: response.current_page,
      lastPage: response.last_page,
      total: response.total,
    }
  },
  async readNotifications({ commit, dispatch }, { http, ids }) {
    const response = await http
      .post(`${process.env.VUE_APP_URL_API_V2}/notificacoes/read-many`, { ids })
      .then(res => res.body)
      .catch(err => {
        throw err.body.mensagem
      })

    return response.mensagem
  },
  async changeArchived({ commit, dispatch }, { http, id, isArchived }) {
    const response = await http
      .patch(`${process.env.VUE_APP_URL_API_V2}/notificacoes/${id}/archive`)
      .then(res => res.body)
      .catch(err => {
        throw err.body.mensagem
      })

    return response.mensagem
  },
  async deleteNotifications({ commit, dispatch }, { http, ids }) {
    const response = await http
      .post(`${process.env.VUE_APP_URL_API_V2}/notificacoes/delete-many`, { ids })
      .then(res => res.body)
      .catch(err => {
        throw err.body.mensagem
      })

    return response.mensagem
  },
  adicionarNotificacao({ commit }, notificacao) {
    commit('ADD_NOTIFICACAO', notificacao)
  },
  adicionarNotificacao({ commit }, notificacao) {
    commit('ADD_NOTIFICACAO', notificacao)
  },
}

export default {
  state,
  mutations,
  actions,
}
